import { addDays, differenceInDays, format } from 'date-fns';

import { types as filterBarTypes } from '../filterBar';
import { UsageAnalyticsGranularity } from './types';
import { GRANULARITY_TYPES } from './constants';

const { HOURLY, DAILY, WEEKLY, MONTHLY } = GRANULARITY_TYPES;

type USABLE_GRANULARITIES = {
  allowed: UsageAnalyticsGranularity[];
  forbidden: UsageAnalyticsGranularity[];
  recommended: UsageAnalyticsGranularity;
};

export const getGranularityForTimeRange = (
  { start, end }: filterBarTypes.DateFilter,
): USABLE_GRANULARITIES => {
  if (start && end) {
    const deltaInDays = Math.abs(differenceInDays(new Date(start), new Date(end)));

    if (deltaInDays <= 7) {
      return {
        allowed: [HOURLY, DAILY],
        forbidden: [WEEKLY, MONTHLY],
        recommended: deltaInDays > 1 ? DAILY : HOURLY,
      };
    }

    if (deltaInDays > 7 && deltaInDays <= 30) {
      return {
        allowed: [DAILY, WEEKLY],
        forbidden: [HOURLY, MONTHLY],
        recommended: WEEKLY,
      };
    }

    if (deltaInDays > 30 && deltaInDays <= 180) {
      return {
        allowed: [WEEKLY, MONTHLY],
        forbidden: [HOURLY, DAILY],
        recommended: MONTHLY,
      };
    }

    return {
      allowed: [MONTHLY],
      forbidden: [HOURLY, DAILY, WEEKLY],
      recommended: MONTHLY,
    };
  }

  // don't really know what to do since there are no dates yet
  // just return some resonable configuration
  return {
    allowed: [HOURLY, DAILY, WEEKLY, MONTHLY],
    forbidden: [],
    recommended: DAILY,
  };
};

export const formatDateForGranularity = (
  date: Date,
  granularity: UsageAnalyticsGranularity,
): string => {
  switch (granularity) {
    case HOURLY:
      return format(date, 'MMM d, yyyy p');

    case DAILY:
      return format(date, 'MMM d, yyyy');

    case WEEKLY:
      return `${format(date, 'MMM d, yyyy')} - ${format(addDays(date, 6), 'MMM d, yyyy')}`;

    case MONTHLY:
      return format(date, 'MMM yyyy');

    default:
      return date.toISOString();
  }
};
